export const italian = {
  seo: {
    title: 'Case: Ristorante Il Municipio | Bistroo',
    description: 'Wie Bistroo dem italienischen Restaurant Il Municipio half, den Trubel zu bewältigen und online zu wachsen.',
  },
  hero: {
    title: 'Wie Bistroo unserem italienischen Restaurant bei der Geschäftigkeit und dem Wachstum half',
    description:
      "Ristorante Il Municipio ist ein renommiertes italienisches Restaurant in Twente, spezialisiert auf authentische Pizzen und Pasta. Ihr Können wurde anerkannt, als sie 2025 den 1. Platz bei der niederländischen Pizzabäcker-Meisterschaft auf der Horecava belegten.",
  },
  testimonials: {
    1: {
      text: '"Bistroo hat wirklich mit uns mitgedacht und Lösungen angeboten, die zu unseren Bedürfnissen und wachsenden Ambitionen passten. Neue Möglichkeiten wurden schnell erdacht und umgesetzt, was für eine nahtlose Zusammenarbeit und eine Verbesserung unseres Kundenservices sorgte"',
      name: 'Roberta',
      job_title: 'Gastgeberin',
    },
    2: {
      text: '"Mit dem Wechsel zu Bistroo müssen wir keine telefonischen Bestellungen mehr entgegennehmen, wodurch wir wertvolle Zeit sparen und mehr Raum für den Service an unseren Kunden haben"',
      name: 'Edwin ter Haar',
      job_title: 'Inhaber',
    },
  },
  challenge: {
    paragraph: {
      title: 'Neue Lösung und Möglichkeiten',
      text: 'Das Restaurant ist bekannt für seine Leidenschaft für hochwertige Zutaten und traditionelle italienische Gerichte. Il Municipio arbeitet bereits seit über 2 Jahren mit Bistroo zusammen und berichtet kurz über die Herausforderungen, die sie vor der Zusammenarbeit hatten, und die Lösungen, die Bistroo bietet.',
    },
    paragraph_2: {
      title: 'Die Herausforderung',
      bullets: {
        1: 'In Stoßzeiten konnte Ristorante Il Municipio von Bestellungen überwältigt werden, wodurch das Restaurant Personal und Kunden länger warten lassen musste.',
        2: 'Die Entgegennahme telefonischer Bestellungen erforderte viel Zeit vom Personal und führte manchmal zu Fehlern oder Missverständnissen.',
        3: 'Als ein schnell wachsendes und sich veränderndes Unternehmen hatte Ristorante Il Municipio Bedarf an einer flexiblen Lösung, die mit seinen sich entwickelnden Bedürfnissen mitwachsen konnte.',
        4: '',
      },
    },
  },
  solution: {
    title: 'Die Lösung',
    checklist: {
      1: "Bistroos Online-Bestelllösung bot Ristorante Il Municipio die Möglichkeit, Kunden digitale Bestätigungen ihrer Bestellungen zu senden. Kunden konnten ihre Bestellungen auf Fehler überprüfen, was die Genauigkeit und Zufriedenheit verbesserte.",
      2: 'Durch den Wechsel zu Bistroo musste das Personal von Ristorante Il Municipio keine telefonischen Bestellungen mehr entgegennehmen, wodurch wertvolle Zeit gespart wird, die für die Zubereitung köstlicher Gerichte und einen ausgezeichneten Kundenservice genutzt werden kann.',
      3: 'Bistroo hat mit Ristorante Il Municipio mitgedacht und Lösungen angeboten, die zu ihren sich ändernden Bedürfnissen und wachsenden Ambitionen passten. Neue Möglichkeiten wurden schnell erdacht und umgesetzt, was für eine nahtlose Zusammenarbeit und besseren Kundenservice sorgte.',
      4: 'Bistroo steht Ristorante Il Municipio jederzeit zur Seite, unabhängig vom Zeitpunkt. Diese kontinuierliche Unterstützung gab dem Restaurant Sicherheit und Vertrauen in seinen Online-Bestellprozess.',
    },
  },
  conclusion: {
    title: 'Das Fazit',
    text: {
      1: "Dank Bistroos Online-Bestelllösung konnte Ristorante Il Municipio nicht nur seine betriebliche Effizienz verbessern, sondern auch seine Kundenzufriedenheit erhöhen und Wachstumsmöglichkeiten nutzen. Das Restaurant schätzte besonders das digitale Bestätigungssystem und die Zeitersparnis, die durch die Eliminierung telefonischer Bestellungen erzielt wurde.",
      2: 'Als Partner, der rund um die Uhr verfügbar ist und auf die Bedürfnisse des Restaurants eingeht, empfiehlt Ristorante Il Municipio Bistroo ausdrücklich anderen Gastronomiebetrieben, die nach einer flexiblen und effizienten Online-Bestelllösung suchen.',
    },
  },
}
